import React, { useContext, useEffect, useState } from "react";
import LoadingButton from "@mui/lab/LoadingButton";
import useRequest from "../../hooks/use-request";
import AuthContext from "../../store/auth-context";
import Loading from "../../components/Loading/Loading";
import Notification from "../../components/Notifications/Notification";
import "./profile.css";

const Profile = () => {
  const [editPassword, setEditPassword] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [id, setId] = useState("");
  const [role, setRole] = useState();
  const [currentPassword, setCurrentPassword] = useState("");
  const [password, setPassword] = useState("");
  const [reapetPassword, setReapetPassword] = useState("");
  const [onSuccessMsg, setOnSuccessMsg] = useState(null);

  const authCtx = useContext(AuthContext);

  useEffect(() => {
    getUser.doRequest();
  }, []);

  const getUser = useRequest({
    url: "/auth/user",
    method: "get",
    headers: {
      Authorization: `Bearer ${authCtx.token}`,
    },
    onSuccess: (data) => {
      setName(data.data.name);
      setEmail(data.data.email);
      setId(data.data.id);
      setRole(data.data.role);
    },
  });

  const updateUserDetails = useRequest({
    url: `/users/email`,
    method: "put",
    headers: {
      Authorization: `Bearer ${authCtx.token}`,
    },
    body: { name: name, email: email },
    onSuccess: (data) => {
      setOnSuccessMsg("Foydalanuvchi ma'lumotlari o'zgartirildi");
    },
  });

  const updateUserPassword = useRequest({
    url: `/users/password`,
    method: "put",
    headers: {
      Authorization: `Bearer ${authCtx.token}`,
    },
    body: {
      currentPassword,
      password,
      reapetPassword
    },
    onSuccess: (data) => {
      setCurrentPassword("");
      setPassword("");
      setReapetPassword("");
      setOnSuccessMsg("Foydalanuvchi paroli o'zgartirildi");
    },
  });

  const onSubmitUpdateUserDetails = async (e) => {
    e.preventDefault();
    setOnSuccessMsg(null);
    await updateUserDetails.doRequest();
  };

  const onSubmitChangePassword = async (e) => {
    e.preventDefault();
    setOnSuccessMsg(null);
      await updateUserPassword.doRequest();
  };

  return (
    <React.Fragment>
      {getUser.loading ? <Loading /> : null}
      <div className="notification-container">
        {updateUserPassword.errors && (
          <Notification status={"error"} message={updateUserPassword.errors} />
        )}
        {updateUserDetails.errors && (
          <Notification status={"error"} message={updateUserDetails.errors} />
        )}
        {onSuccessMsg ? (
          <Notification status={"success"} message={onSuccessMsg} />
        ) : null}
      </div>
      <div className="profile-container">
        <div className="right-section">
          <div className="right-section-header">
            <div
              className={
                editPassword
                  ? "right-section-control"
                  : "right-section-control active"
              }
            >
              <button onClick={() => setEditPassword(false)}>
                Edit Details
              </button>
            </div>
            <div
              className={
                !editPassword
                  ? "right-section-control"
                  : "right-section-control active"
              }
            >
              <button onClick={() => setEditPassword(true)}>
                Change Password
              </button>
            </div>
          </div>
          {!editPassword ? (
            <div className="right-section-details">
              <form onSubmit={onSubmitUpdateUserDetails}>
                <div className="detail">
                  <label>Fullname</label>
                  <input
                    type={"text"}
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    required
                  />
                </div>
                <div className="detail">
                  <label>Email</label>
                  <input
                    type={"text"}
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>
                <div style={{ margin: "20px 0" }}>
                  <LoadingButton
                    loading={updateUserDetails.loading}
                    variant="contained"
                    type="submit"
                  >
                    Save Changes
                  </LoadingButton>
                </div>
              </form>
            </div>
          ) : (
            <div className="right-section-details">
              <form onSubmit={onSubmitChangePassword}>
                <div className="detail">
                  <label>Current Password</label>
                  <input
                    type={"password"}
                    value={currentPassword}
                    onChange={(e) => setCurrentPassword(String(e.target.value))}
                    required
                  />
                </div>
                <div className="detail">
                  <label>New Password</label>
                  <input
                    type={"password"}
                    value={password}
                    onChange={(e) => setPassword(String(e.target.value))}
                    required
                  />
                </div>
                <div className="detail">
                  <label>Reapet New Password</label>
                  <input
                    type={"password"}
                    value={reapetPassword}
                    onChange={(e) => setReapetPassword(String(e.target.value))}
                    required
                  />
                </div>
                <div style={{ margin: "20px 0" }}>
                  <LoadingButton
                    className="btn"
                    loading={updateUserPassword.loading}
                    type="submit"
                    variant="contained"
                  >
                    Save Changes
                  </LoadingButton>
                </div>
              </form>
            </div>
          )}
        </div>
      </div>
    </React.Fragment>
  );
};

export default Profile;
